<template>
  <div class="address">
    <div class="address__city">
      {{ city }}
    </div>
    <div class="address__date">
      {{ dateFormated }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'addressHeader',
  props: {
    city: {
      default: '',
      type: String,
    },
    dateFrom: {
      default: '',
      type: String,
    },
    dateTo: {
      default: '',
      type: String,
    },
  },
  computed: {
    dateFormated() {
      const dateFrom = new Date(this.dateFrom);
      const dateTo = new Date(this.dateTo);
      return this.$helpers.demand.formatDates(dateFrom, dateTo);
    },
  },
};
</script>

<style scoped lang="scss">
.address {
  display: flex;
  flex-direction: column;
  margin: auto 10px;
  @include breakpoint(tablet) {
    margin: auto 20px;
  }
  &__city {
    font-weight: 700;
  }
}
</style>
